import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  updateMeetingRoom,
  resetMeetingRoomForm,
  updateSelectedParticipantInMRForm,
} from '../../../../actions/meetingRoom';
import { updateShowMeetingRoomParticipant } from '../../../../actions/modal';
import { disconnectCaller } from '../../../../actions/meetingRoom';

export default function RightPanelViewMeetingRoomParticipant(props) {
  const dispatch = useDispatch();
  const [disconnectUser, setDisconnectUser] = useState(false);
  const [disconnectUserLoader, setDisconnectUserLoader] = useState(false);

  // focus on btn in modal so that ESC key can work
  const participant_modal_btn_notDis = useRef(null);
  const participant_modal_btn_dis = useRef(null);
  useEffect(() => {
    participant_modal_btn_notDis.current && participant_modal_btn_notDis.current.focus();
    participant_modal_btn_dis.current && participant_modal_btn_dis.current.focus();
  }, [props]);

  const verifyDisconnectParticipant = () => {
    setDisconnectUser(!disconnectUser);
  };
  const disconnectParticipant = () => {
    setDisconnectUserLoader(true);
    let cb = (successfull) => {
      setDisconnectUserLoader(false);
      closeViewParticipantModal();
    };
    dispatch(disconnectCaller(props.participantFormData.vidyoCallId, props.participantFormData.name, cb));
  };

  const closeViewParticipantModal = () => {
    let show = false;
    dispatch(updateShowMeetingRoomParticipant(show));
    dispatch(
      updateSelectedParticipantInMRForm({
        selectedParticipant: {},
        isUserInThisCall: false,
      })
    );
  };

  let disconnectClasses =
    'ui labeled icon button icon left-text color-button mrbnull color-button-hover mrpcrxs color-white   mrlnull  max-width';

  let buttonsForUser = '';
  buttonsForUser = (
    <div className="ui actions mrbs max-width ">
      <button
        ref={participant_modal_btn_notDis}
        type="button"
        onClick={verifyDisconnectParticipant}
        data-show={!disconnectUser}
        className="ui  labeled icon button left-text color-bad-things-hover max-width mrts mrlnull color-info mrbnull"
      >
        {window.APP.LANGUAGE.Disconnect}
        <i className="sign in icon " />
      </button>

      <button
        onClick={closeViewParticipantModal}
        type="button"
        data-show={!disconnectUser}
        className="ui cancel labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width mrtm mrlnull mrbnull"
      >
        <i className="remove  icon" />
        {APP.LANGUAGE.Close}
      </button>

      <h4 className="mrts" data-show={disconnectUser}>
        {window.APP.LANGUAGE.MeetingRoomPersonStatus.ConfirmationDisconnect.replace(
          '##meetingRoomParticipant##',
          props.participantFormData.name
        )}
      </h4>
      <button
        ref={participant_modal_btn_dis}
        type="button"
        onClick={disconnectParticipant}
        data-show={disconnectUser}
        className={disconnectUserLoader ? disconnectClasses + ' loading' : disconnectClasses}
      >
        {APP.LANGUAGE.Yes}
        <i className="checkmark icon " />
      </button>

      <button
        onClick={closeViewParticipantModal}
        type="button"
        data-show={disconnectUser}
        className="ui cancel mrtm labeled icon button color-bad-things left-text color-bad-things-hover color-white max-width  mrlnull mrbnull mrrnull"
      >
        <i className="remove  icon" />
        {APP.LANGUAGE.No}
      </button>
    </div>
  );

  return <span>{buttonsForUser}</span>;
}
